import { getFileNameExcel } from "helpers/utils";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import React from "react";
import ListExport from "./ListExport";

const ListExportInvoicePos = props => {
  return (
    <ListExport
      typeReport={TYPE_REPORT.INVOICE_POS}
      fileNameExport={getFileNameExcel("DanhSachHoaDonMTT")}
    />
  );
};

export default ListExportInvoicePos;
